export default __webpack_public_path__ + "static/media/hidden-ai.7fdaea2d.svg";